import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

/**
 * Delete a form template key
 */
export async function deleteFormTemplateKey(
  keyId: string
): Promise<{ success: boolean }> {
  try {
    const res = await fetcher(`${BASE_URL}/${keyId}`, {
      method: 'DELETE',
    });

    if (!res.ok) {
      console.error('Failed to delete form template key:', await res.text());
      return { success: false };
    }

    return { success: true };
  } catch (err) {
    console.error('Error deleting form template key:', err);
    return { success: false };
  }
}

